import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import Box from '@mui/material/Box';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { deleteFeedThunk, generateFeedThunk, getFeedsThunk } from '../../../../actions/feeds';
import { DeleteButton } from '../../../../components/Button/deleteButton';
import { CopyToClipboard } from '../../../../components/CopyToClipboard';
import { TypesButton } from '../../../../constants/ButtonTypes';
import { routes } from '../../../../constants/RouterPath';
import { SizesButton } from '../../../../constants/SizeButton';
import { FontWeight } from '../../../../constants/Styles/fontWeight';
import { getFormatDate } from '../../../../helpers/date/getDate';
import { selectFeeds } from '../../../../selectors/feeds';
import { selectSearchData } from '../../../../selectors/search';
import { useAppDispatch, useTypeSelector } from '../../../../store';
import { TypesIcon } from '../../../../types/TypesIcon';
import { titlesTable } from '../../constants';
import { StyledEditButton, StyledReloadIcon, styles } from './styles';

export const FeedsTable: FC = () => {
    const history = useHistory();
    const dispatch = useAppDispatch();
    const feeds = useTypeSelector(selectFeeds);
    const searchString = useTypeSelector(selectSearchData);
    const filteredFeeds = feeds
        .filter(({ title }) => title.toLowerCase().includes((searchString || '').toLowerCase()))
        .sort((a, b) => a.id - b.id);

    const onDelete = async (id: number) => {
        await dispatch(deleteFeedThunk(id));
        await dispatch(getFeedsThunk({}));
    };

    const onReload = async (id: number) => {
        await dispatch(generateFeedThunk(id));
        await dispatch(getFeedsThunk({}));
    };

    return (
        <>
            {filteredFeeds.length > 0 && (
                <TableContainer component={Paper} sx={styles.root}>
                    <Table sx={{ minWidth: '100%' }} aria-label="simple table">
                        <TableHead sx={styles.root}>
                            <TableRow
                                sx={{
                                    'td, th': { border: 0, fontWeight: FontWeight.BOLD },
                                }}
                            >
                                {titlesTable.map(item => (
                                    <TableCell key={`${item}`}>
                                        {item}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody sx={[styles.root, styles.body]}>
                            {filteredFeeds.map(row => (
                                <TableRow
                                    key={row.id}
                                    sx={{ 'td, th': { border: 0 } }}
                                >
                                    <TableCell
                                        component="th"
                                        scope="row"
                                        className="text-grey"
                                        sx={{ width: '5%' }}
                                    >
                                        <span>{row.id}</span>
                                    </TableCell>

                                    <TableCell align="left" sx={{ width: '35%' }}>
                                        {row.title}
                                    </TableCell>
                                    <TableCell align="left" sx={{ width: '40%' }}>
                                        {row.generatedAt ? getFormatDate(row.generatedAt) : ''}
                                    </TableCell>

                                    <TableCell
                                        align="left"
                                        sx={{
                                            width: '10%',
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            <CopyToClipboard copyText={row.link ?? undefined} disabledText={row.link ? undefined : 'На текущий момент фид не сгенерирован!'} />
                                            <StyledReloadIcon
                                                type={TypesIcon.RELOAD}
                                                onClick={() => onReload(row.id)}
                                            />
                                            <StyledEditButton
                                                typeButton={TypesButton.SECONDARY}
                                                size={SizesButton.M}
                                                onClick={() => history.push(`${routes.feeds_edit}/${row.id}`)}
                                            />
                                            <DeleteButton
                                                onClick={() => onDelete(row.id)}
                                                typeButton={TypesButton.DELETE}
                                                size={SizesButton.M}
                                            />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
            {filteredFeeds.length === 0 && <p>Записей не найдено</p>}
        </>
    );
};
